if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      //this.form.querySelector('[name=id]').disabled = false;
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}
  // PATCH: Actualizar precio y compare-at al cambiar variante
document.addEventListener('variant:changed', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  // Selectores del Dazzle theme
  const priceEl = document.querySelector('.price-item--regular:not(.variant-item__old-price)');
  const salePriceEl = document.querySelector('.price-item--sale');
  const compareEl = document.querySelector('.variant-item__old-price, .price-item--regular small');

  const price = variant.price / 100; // Shopify usa centavos
  const compareAt = variant.compare_at_price ? variant.compare_at_price / 100 : null;

  // Update price
  if (priceEl) {
    priceEl.textContent = price.toLocaleString('en-US', {
      style: 'currency',
      currency: window.Shopify.currency.active || 'USD'
    });
  }

  // Update sale price if exists
  if (salePriceEl) {
    salePriceEl.textContent = price.toLocaleString('en-US', {
      style: 'currency',
      currency: window.Shopify.currency.active || 'USD'
    });
  }

  // Update compare-at (tachado)
  if (compareEl) {
    if (compareAt && compareAt > price) {
      compareEl.style.display = 'inline';
      compareEl.textContent = compareAt.toLocaleString('en-US', {
        style: 'currency',
        currency: window.Shopify.currency.active || 'USD'
      });
    } else {
      compareEl.style.display = 'none';
    }
  }
  });
  // ✅ Actualizar precios al cambiar variante (para Dazzle con swatch buttons)
document.querySelectorAll('.swatch-input__input').forEach((el) => {
  el.addEventListener('change', () => {
    const selectedVariantId = document.querySelector('input[name="id"]').value;
    if (!window?.productVariants) return;

    const variant = window.productVariants.find(v => v.id == selectedVariantId);
    if (!variant) return;

    const priceEl = document.querySelector('.price-item--regular:not(.variant-item__old-price)');
    const compareEl = document.querySelector('.variant-item__old-price, .price-item--regular small');

    const price = variant.price / 100;
    const compareAt = variant.compare_at_price ? variant.compare_at_price / 100 : null;

    if (priceEl) {
      priceEl.textContent = price.toLocaleString('en-US', {
        style: 'currency',
        currency: window.Shopify.currency.active || 'USD'
      });
    }

    if (compareEl) {
      if (compareAt && compareAt > price) {
        compareEl.style.display = 'inline';
        compareEl.textContent = compareAt.toLocaleString('en-US', {
          style: 'currency',
          currency: window.Shopify.currency.active || 'USD'
        });
      } else {
        compareEl.style.display = 'none';
      }
    }
  });
});
